import React, { useState, useEffect} from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { get_cookies } from "../../../components/Cookies/Cookies";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "500px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		borderRadius:5,
		padding: theme.spacing(2, 4, 3),
		width: "500px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
		'&$disabled': {
			color: '#f2f2f2',
		 }
	},
	disabled: {},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddSystemUser(props) {
	const {showModal} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [positionData, setPositionData] = useState([]);
	const [branchIdData, setBranchIdData] = useState([]);
	const [positionId, setPositionId] = useState('');
	const [fname, setFname] = useState('');
	const [mname, setMname] = useState('');
	const [lname, setLname] = useState('');
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [branchidno, setBranchidno] = useState('');

	const [confirmPassword, setConfirmPassword] = useState('');

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(true);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	  const [loading, setLoading] = useState(false);
	//Message Box EOF

	const clearFields = () => {
		setFname('');
		setMname('');
		setLname('');
		setUsername('');
		setPassword('');
		setConfirmPassword('');
		setBranchidno('');
		setPositionId('');
	};

	const handleOpen = () => {
		setOpen(true);
		clearFields();
	};

	const handleClose = () => {
		setOpen(false);
	};


	const getUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_user_roles', {
			}).then(function (res) {
				setPositionData(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	  		});
	}
	
	const getBranchIdData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_branches', {
			}).then(function (res) {
				setBranchIdData(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	  		});
	}

	const selectSupplierProps = {
		options: positionData,
		getOptionLabel: (option) => option.position,
	};
	
	const selectBranchIdProps = {
		options: branchIdData,
		getOptionLabel: (option) => option.idno,
	};

	useEffect(() => { //
		getUserRoleData();
		getBranchIdData();
	}, []);

	const removeDuplicates = (array) => {
		return [...new Set(array)];
	}

	useEffect(() => {
		if (positionId && fname && username ) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [positionId,fname,username]);


		const spinnerStyle = {
		border: "4px solid #f3f3f3",
		borderTop: "4px solid #3498db",
		borderRadius: "50%",
		width: "24px",
		height: "24px",
		animation: "spin 1s linear infinite",
		margin: "10px auto",
		};

		const spinKeyframes = `
		@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
		}
		`;


	const saveSystemUser = async (position_name, main_nav, content_nav) => {
	setBtnDisabled(true);
	setLoading(true);
		if(fname && username){
			// let password = generateTempPassword();
			const formData = new FormData();
			formData.append("position_id", positionId);
			formData.append("fname", fname);
			formData.append("mname", mname);
			formData.append("lname", lname); 
			formData.append("username", username); 
			formData.append("createdby", get_cookies('username')); 
			formData.append("branchidno", get_cookies('branchidno'));
	
			await axios.post(process.env.REACT_APP_API_URL+'add_system_user', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {	
					if(res.data[0].success ==0){
						setLoading(false);
					showModal('Username Already Taken', 'error');
					setBtnDisabled(false);
					}else{
					setLoading(false);
					showModal('Added new System User '+ username, 'success');
						setBtnDisabled(false);
					handleClose();
					 }

				  }).catch(function (error) {
							setLoading(false);
					showModal('Something went wrong '+ error.message, 'warning');
						setBtnDisabled(false);
					handleClose();
				  });
		}else{
					setLoading(false);
			showModal('Passwords must match / Fields must not be empty', 'warning');
			// handleClose();
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		saveSystemUser();
    }

	const handleClickShowPassword = (flag) => {
		if(flag === 'password'){
			setShowPassword(!showPassword);
		}else if(flag === 'confirm'){
			setShowConfirmPassword(!showConfirmPassword);
		}
	  };
	
	  const handleMouseDownPassword = (event) => {
		event.preventDefault();
	  };

	  function hasNumber(myString) {
			if (myString.trim() === "") return false;

			// Allowed: letters, numbers, underscore, dot, dash, @
			const regex = /^[A-Za-z0-9._@\- ]+$/;
			return regex.test(myString);
	  }

	  const validateUsername = (username) => {
		let isValidName = hasNumber(username);
		// let isValidName = username.match(/^(([a-z])+([0-9])+|([a-z])+)/);
		if(!isValidName){
			setUsername('');
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Invalid Username');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  const validateName = (username,flag) => {
		// let isValidName = username.match(/([a-z])|([A-Z])/);
		let isValidName = hasNumber(username);
		if(!isValidName){
			// setUsername('');
			if(flag==='fname'){
				setFname('');
			}else if(flag === 'mname'){
				setMname('');
			}else if(flag === 'lname'){
				setLname('');
			}
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Numbers Not Allowed in Name Fields');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  

	  const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	return (
		<div>
	
			<Button variant="contained" color="primary" onClick={handleOpen} style ={{marginTop: "22px", marginLeft:"10px",backgroundColor: "#4caf50", color:"#fff"}}>
				Add System User
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
							<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<style>{spinKeyframes}</style>
						{loading && <div style={spinnerStyle}></div>}
						{loading == false?<>						<h4 id="transition-modal-title">Add System User</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<Autocomplete
												{...selectSupplierProps}
												id="auto-complete"
												autoComplete
												includeInputInList
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select User Role"
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														console.log(newValue);
														setPositionId(newValue.position_id);
													}else{
														setPositionId(null);
													}
												}}
									/>
								</Grid>		
								<Grid item xs={12} md={12} lg={12} xl={12}> 
									<TextField id="outlined-basic" style={{'marginTop':'16px'}} label="User Name" variant="outlined" placeholder="Cashier or Cashier123" inputProps={{ 'aria-label': 'User Name' }} value={username} 
									onChange={e => setUsername(e.target.value)}
									onBlur={(e)=>{validateUsername(e.target.value)}}
									/>
								</Grid>	
								<Grid item xs={12} md={12} lg={12} xl={12}> 
									<TextField id="outlined-basic" 
										label="Full Name" 
										variant="outlined"  style={{marginTop:"21px"}} 
										placeholder="Fulll Name" fullWidth={true} 
										inputProps={{ 'aria-label': 'Full Name'}} 
										value={fname} 
										onChange={e => setFname(e.target.value)}
										onBlur={(e)=>{validateName(e.target.value,'fname')}}
									/>
									  <Typography variant="body2" style={{ marginTop: "8px", color: "orange" }}>
										Note: Your password will be sent to your email.
										</Typography>
								</Grid>	

							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<ColorButton type="submit" disabled={btnDisabled} variant="contained" color="primary" classes={{
    									root: classes.root, 
        								disabled: classes.disabled}}>
									Add System User
								</ColorButton>
							</div>
						</form></>:null}
					

					</div>
				</Fade>
			</Modal>
		</div>
	);
}
